import React from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router';

import { selectors, actions } from './';

import wrapMain from '../../wrap-main';

import Table from '../../../shared/new-table/main';

import table from './table-initial-data';

function Main({ intl, rows, can, remove }) {
	return (
		<div>
			<div className='banners-navigation'>
				<Link
					className='ui-btn ui-btn-primary'
					to='/offer-location-rules/geo-rules/new'
				>
					{intl('Create geo rule')}
				</Link>
			</div>
			<Table
				className='banners-table'
				table={table}
				rows={rows}
				payload={{ can, remove }}
			/>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		rows: selectors.select(state, 'data'),
		// -----------------------------------------
		can: selectors.getCan(state)
	};
}

export default connect(mapStateToProps, actions.own)(wrapMain(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/geo-rules/list/main.js